import React from 'react';
import PropTypes from 'prop-types';
import { H5, P } from 'components/Typography';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import history from 'routing/history';
import {
  ERROR_MESSAGE_DEFAULT,
  ERROR_TITLE_DEFAULT
} from 'products/nomad_insurance/constants';
import validation from './validation';
import {
  ResetPasswordContainer,
  Bird,
  ContentWrapper,
  PasswordInput,
  StyledSpinner,
  LoginButton,
  SaveButton,
  ErrorAlert
} from './styled';
import { resetPassword } from '../state';

const ResetPassword = ({ token, email }) => {
  const dispatch = useDispatch();
  const { isLoading, isReset, error } = useSelector(
    (state) => state.global.forgotPassword
  );

  const formik = useFormik({
    initialValues: {
      password: ''
    },
    validationSchema: validation,
    onSubmit: ({ password }) => dispatch(resetPassword(email, password, token))
  });

  const renderError = () => {
    switch (error.type) {
      case 'RESET__INVALID_TOKEN':
        return (
          <ErrorAlert variant="warning" label="Invalid url">
            Couldn't reset password because the token in the reset url is wrong!
          </ErrorAlert>
        );
      default:
        return (
          <ErrorAlert variant="danger" label={ERROR_TITLE_DEFAULT}>
            {ERROR_MESSAGE_DEFAULT}
          </ErrorAlert>
        );
    }
  };

  return (
    <ResetPasswordContainer>
      <Bird />
      <ContentWrapper>
        <H5>{isReset ? 'New password succesfully saved.' : 'Reset password'}</H5>
        <P>{email}</P>
        {error && renderError()}
        {!isLoading && !isReset && (
          <>
            <PasswordInput
              label="New password"
              variant="light"
              name="password"
              formik={formik}
            />
            <SaveButton
              disabled={!formik.isValid || !formik.dirty}
              onClick={formik.submitForm}
            >
              Save
            </SaveButton>
          </>
        )}
        {isLoading && !isReset && <StyledSpinner />}
        {isReset && !isLoading && (
          <LoginButton onClick={() => history.push('/login')}>Login</LoginButton>
        )}
      </ContentWrapper>
    </ResetPasswordContainer>
  );
};

ResetPassword.propTypes = {
  token: PropTypes.string,
  email: PropTypes.string
};

export default ResetPassword;
